<div class="tw-p-spacing-100">
  <span [ngClass]="sizeClass()">
  <svg viewBox="0 0 16 16"
       xmlns="http://www.w3.org/2000/svg"
       [ngClass]="sizeClass()">
      <circle cx="8" cy="8" r="7"
              [ngClass]="strokeColorClass()"/>
    </svg>
  </span>
</div>
